import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
import EFGoodDesign from '@/components/UI/svg/Delta2/Icon/EFGoodDesign';

const { EFPic } = createEFPic('/media/delta2/pc/');

export default function ProsThink({}: any) {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta2portablepowerstation');

    const thinkList = [
        {
            // <EFCNN />,
            avatar: <EFPic name={['EFCNN.webp', 'EFCNN.png']} className="fullImgs" />,
            text: t('delta2.think_cnn'),
            style: { width: 267, height: 55 },
        },
        {
            // <EFDIFA2022 />,
            avatar: <EFPic name={['EFDIFA2022.webp', 'EFDIFA2022.png']} className="fullImgs" />,
            text: t('delta2.think_make_use'),
            style: { width: 71, height: 55 },
        },
        {
            // <EFDigitalTrends />,
            avatar: <EFPic name={['EFDigitalTrends.webp', 'EFDigitalTrends.png']} className="fullImgs" />,
            text: t('delta2.think_digital'),
            style: { width: 313, height: 55 },
        },
        {
            // <EFRandRoid />,
            avatar: <EFPic name={['EFRandRoid.webp', 'EFRandRoid.png']} className="fullImgs" />,
            text: t('delta2.think_frAndroid'),
            style: { width: 302, height: 55 },
        },
    ];

    if (locale === 'au') {
        thinkList.push({
            avatar: <EFGoodDesign />,
            text: t('delta2.think_good_design'),
            style: {},
        });
    }

    return (
        <div className={`${css.prosThink} pros-think GtmModuleData-section`} data-section-id={css.prosThink} data-section-title={t('delta2.think_title')}>
            <div className="title">{t('delta2.think_title')}</div>
            <div className="think-wrapper">
                {thinkList.map((item, index) => (
                    <div className="think-panel" key={index}>
                        <div className="avatar" style={item.style}>
                            {item.avatar}
                        </div>
                        <div className="text">{item.text}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}
